import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Authenticate } from '@kanzi-apes/kanzi-models';
import {
  UntypedFormGroup,
  Validators,
  UntypedFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { KanziAlertsModule } from '@kanzi-apes/kanzi-alerts';
import { KanziPrimeUiModule } from '@kanzi-apes/kanzi-prime-ui';
import { TranslatePipe } from '@ngx-translate/core';

/**
 * @author Hugo Andrés Escobar Ciceri
 * @version 5.0.0
 *
 * Form Component to Login Component
 */
@Component({
    selector: 'kanzi-apes-login-form',
    imports: [
        CommonModule,
        KanziAlertsModule,
        KanziPrimeUiModule,
        ReactiveFormsModule,
        TranslatePipe,
    ],
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent {
  @Input()
  set pending(isPending: boolean) {}
  @Input() errorMessage = '';
  @Output() submitted = new EventEmitter<Authenticate>();

  login: Authenticate;
  loginFormGroup: UntypedFormGroup = this.fb.group({
    username: ['', Validators.required],
    password: ['', Validators.required],
  });

  constructor(private fb: UntypedFormBuilder) {
    this.login = {
      username: '',
      password: '',
    };
  }

  get username() {
    return this.loginFormGroup.get('username');
  }

  get password() {
    return this.loginFormGroup.get('password');
  }

  /**
   *
   * @param  formControls
   */
  onSignIn() {
    if (this.loginFormGroup.valid) {
      this.submitted.emit(this.loginFormGroup.value);
    }
  }
}
